import api from './api';

/*
 * API client for GIFT SHARES — several givers chip in on one expensive wish,
 * coordinated by whoever claimed it (the coordinator). Coordinate-only: this is
 * a ledger of pledges, never a movement of money. See FEEDBACK_PLAN.md §6.
 *
 * The flow: the wisher marks a wish shareable (share_count / estimated_price on
 * the wish itself) → a giver CLAIMS it (the existing claim endpoint) and so
 * becomes the coordinator → other givers PLEDGE pieces and/or a dollar amount →
 * the coordinator ACKNOWLEDGES each pledge as it's committed. Owner-blindness:
 * the wisher never receives the contributions array or the coordinator, so this
 * whole surface is invisible to them.
 *
 * Each contribution row: { id, user_id, shares_pledged, amount,
 *   status: "pledged" | "acknowledged" | "withdrawn", acknowledged_at, user }.
 *
 * Every function returns the already-unwrapped payload — the shared axios
 * instance (services/api.js) strips the { success, data, ... } envelope.
 */

// POST /wishes/{wishId}/pledges — record a pledge of pieces and/or an amount.
// A coordinator (claimer) must already exist, and the actor must share a group
// with the wish. Values are ≥ 1 / positive; empty fields are omitted.
export async function pledge(wishId, { shares_pledged, amount } = {}) {
    const payload = {};
    if (shares_pledged != null && shares_pledged !== '') payload.shares_pledged = Number(shares_pledged);
    if (amount != null && amount !== '') payload.amount = Number(amount);
    const res = await api.post(`/wishes/${wishId}/pledges`, payload);
    return res.data;
}

// POST /contributions/{id}/acknowledge — coordinator marks a pledge received.
export async function acknowledgePledge(contributionId) {
    const res = await api.post(`/contributions/${contributionId}/acknowledge`);
    return res.data;
}

// DELETE /contributions/{id} — the pledger withdraws their own still-pending
// ('pledged') contribution.
export async function withdrawPledge(contributionId) {
    const res = await api.delete(`/contributions/${contributionId}`);
    return res.data;
}
